<template>
    <div
        class="w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-150"
        @click.stop.prevent="openFileUploadDialog"
    >
        <div class="d-flex flex-column align-items-center font-size-125 py-3">
            <i class="fa fa-cloud-upload-alt fa-5x vue-uploadbox-icon"></i>
            <span class="px-1 text-center vue-uploadbox-drop-text" :class="darkText">
                {{ 'Drop Files here' | trans }}
            </span>
        </div>

        <div class="btn-group">
            <button
                type="button"
                class="btn btn-light font-size-125 font-weight-bold text-nowrap vue-uploadbox-file-button position-static"
                @click.stop.prevent="openFileUploadDialog"
                :class="{ 'rounded-bottom-0': showDropdown }"
            >
                {{ 'Choose File' | trans }}
            </button>
            <button
                type="button"
                class="btn btn-light dropdown-toggle dropdown-toggle-split border-left"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click.stop.prevent="toggleDropdown"
                :class="{ 'rounded-bottom-0': showDropdown }"
            >
                <i class="fa fa-chevron-down"></i>
            </button>
            <div
                id="dropdownMenu"
                :class="{ show: showDropdown }"
                class="dropdown-menu m-0 w-100 br-4 rounded-top-0 user-select-none"
            >
                <div class="dropdown-item px-0">
                    <span
                        id="DeviceUploadButton"
                        class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                        @click.stop.prevent="openFileUploadDialog"
                        :title="'Upload From Device' | trans"
                        tag="span"
                    >
                        <span class="px-75"> <i style="width: 15px" class="fa fa-folder-open"></i> </span
                        >{{ 'From Device' | trans }}
                    </span>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item px-0">
                    <span
                        id="dropboxButton"
                        class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                        :title="'Choose one or more files from Dropbox' | trans"
                        @click.stop.prevent="openDropboxDialog"
                    >
                        <span class="px-75">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 40" version="1.1" width="15px">
                                <path
                                    d="m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z"
                                    fill="#007EE5"
                                />
                            </svg> </span
                        >{{ 'From Dropbox' | trans }}
                    </span>
                </div>
                <div class="dropdown-divider"></div>
                <div
                    class="dropdown-item px-0"
                    @click.stop.prevent="openGdriveDialog"
                    :class="{ 'opacity-65': disableGdriveButton }"
                >
                    <span
                        id="gdriveButton"
                        class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                        :title="'Choose one or more files from Google Drive' | trans"
                    >
                        <span class="px-75">
                            <svg width="15px" viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z"
                                    fill="#0066da"
                                />
                                <path
                                    d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z"
                                    fill="#00ac47"
                                />
                                <path
                                    d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z"
                                    fill="#ea4335"
                                />
                                <path
                                    d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z"
                                    fill="#00832d"
                                />
                                <path
                                    d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
                                    fill="#2684fc"
                                />
                                <path
                                    d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z"
                                    fill="#ffba00"
                                />
                            </svg> </span
                        >{{ 'From Google Drive' | trans }}
                    </span>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item px-0">
                    <RouterLink
                        class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                        id="externalUrlButton"
                        :to="{ name: 'remote-url' }"
                        :title="'Enter the link of a file you want to use' | trans"
                        tag="span"
                    >
                        <span class="px-75"> <i style="width: 15px" class="fa fa-link"></i> </span
                        >{{ 'From URL' | trans }}
                    </RouterLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { getGlobalUploader } from '../../global-uploader';
import { pageNotification } from '../../../../qaamgo/helper/notify';
import { globalLogger } from '../../../../qaamgo/helper/global-logger';
import { satGlobals } from '../../../../qaamgo/sat/helper/sat-globals';

export default {
    name: 'FileUploadView',
    mixins: [TransFilter],
    mounted() {
        document.addEventListener('click', this.closeDropdown);
    },
    data() {
        return {
            showDropdown: false,
            disableGdriveButton: false,
        };
    },
    methods: {
        openDropboxDialog() {
            this.closeDropdown();
            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('openDropboxDialog - no uploader defined');

                return;
            }

            uploader.clickDropBox();
        },
        openGdriveDialog(event) {
            this.closeDropdown();
            if (this.disableGdriveButton) return;
            this.disableGdriveButton = true;
            setTimeout(() => (this.disableGdriveButton = false), 1000);
            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('openGdriveDialog - no uploader defined');

                return;
            }

            uploader.clickGdrive();
        },
        openFileUploadDialog() {
            this.closeDropdown();
            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('openFileUploadDialog - no uploader defined');

                return;
            }

            uploader.clickFileUpload();
        },
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        closeDropdown() {
            this.showDropdown = false;
        },
    },
    computed: {
        darkText() {
            if (window.pageConfig.uploaderTextColor) {
                return window.pageConfig.uploaderTextColor;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.dropdown-item.active,
.dropdown-item:active {
    color: #2e2e2e;
    background-color: #f5f5f5;
}
.dropdown-item:focus,
.dropdown-item:hover {
    color: #2e2e2e;
    background-color: #f5f5f5;
}
</style>
